export default __webpack_public_path__ + "static/media/legislative-and-budget-process.0a2e14b3.png";